import {yupResolver} from '@hookform/resolvers/yup'
import {useEffect, useRef, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {StepperComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {useAuth} from '../../../../../../hooks/useAuth'
import {formatDate} from '../../../../../../util/dates'
import {getSiteById} from '../../../../../central/services'
import {MultiUserCrewModel} from '../../../../model/multiUserCrew.model'
import {multiUserCrewSchema} from '../../../../schema/multiUserCrew'
import {CensusStep} from './census-step'
import {ProgrammingStep} from './programming-step'
import {RegistrationStep} from './registration-step'
import {ScanningStep} from './scanning-step'

const inits: MultiUserCrewModel = {
  census: false,
  censusOk: false,
  hasCrewUsers: false,
  hasCrewLeader: false,
  CampamentoId: '',
  ProgramacionServicioId: '',
  ModuloId: '',
  HabitacionId: '',
  FechaInicio: formatDate(new Date()),
  FechaFin: formatDate(new Date()),
  EscaneoId: '',
  Estados: [],
  searchProgrammingCounter: 0,
  ActividadesCompletadas: false,
}

export const MultiUserCrewForm = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(multiUserCrewSchema[0])
  const [initValues] = useState<MultiUserCrewModel>(inits)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const {user} = useAuth()

  const methods = useForm<MultiUserCrewModel>({
    defaultValues: initValues,
    resolver: yupResolver(currentSchema),
  })

  const {reset, setValue} = methods

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentSchema(multiUserCrewSchema[currentStepIndex - 1])
    setCurrentStepIndex((prevIndex) => prevIndex - 1)
  }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }

    setCurrentSchema(multiUserCrewSchema[currentStepIndex])

    if (currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext()
      setCurrentStepIndex((prevIndex) => prevIndex + 1)
    }
  }

  const goToFirstStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(1)
    setCurrentStepIndex(0)
    setCurrentSchema(multiUserCrewSchema[0])
    reset()
  }

  const goToStep = (index: number) => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(index)
    setCurrentStepIndex(index - 1)
    setCurrentSchema(multiUserCrewSchema[index - 1])
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  const getSiteInfo = async () => {
    if (user.lstSites.length === 0) {
      return
    }
    const siteId = user.lstSites[0].SiteId
    try {
      const {data: response} = await getSiteById(siteId)
      if (!response.error) {
        setValue('census', response.data.requiereCenso || false)
        setValue('censusOk', true)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getSiteInfo()
  }, [])

  return (
    <div className='card'>
      <div className='card-body'>
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
        >
          <div className='stepper-nav'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <h3 className='stepper-title fs-6 fs-md-5 fs-lg-4'>Registro</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title fs-6 fs-md-5 fs-lg-4'>Censo</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title fs-6 fs-md-5 fs-lg-4'>Programación</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title fs-6 fs-md-5 fs-lg-4'>Escaneo</h3>
            </div>
            {/* <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title fs-6 fs-md-5 fs-lg-4'>Resultados</h3>
            </div> */}
          </div>

          <FormProvider {...methods}>
            <form className='mx-auto mw-600px w-100 py-4' id='kt_create_account_form'>
              {currentStepIndex === 0 && (
                <RegistrationStep nextStep={nextStep} prevStep={prevStep} goToStep={goToStep} />
              )}
              {currentStepIndex === 1 && (
                <CensusStep
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 2 && (
                <ProgrammingStep
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 3 && (
                <ScanningStep
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {/* {currentStepIndex === 4 && (
                <ResultStep
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )} */}
            </form>
            {/* <pre>{JSON.stringify(methods.watch(), null, 2)}</pre> */}
          </FormProvider>
        </div>
      </div>
    </div>
  )
}
